import {  Flex, Heading, Text } from "@chakra-ui/react";
import { Button } from "barte-design-system";

import { SetStateAction } from "react";
import { canViewTransferList, hasWithdrawPermission, isWithdrawDisabled } from "./_withdrawRules";
interface SaldoComponentProps {
    data?: any;
    open?: React.Dispatch<SetStateAction<boolean>>
    openTransferList?: React.Dispatch<SetStateAction<boolean>>
    type?: "acquirer_account" | "debit_account" | "credit_account"
    hasTitle?: boolean
}




export function SaldoComponent({ data, open, openTransferList, type = "acquirer_account", hasTitle = false }: SaldoComponentProps) {
    const featureToggle = JSON.parse(localStorage.getItem("barte-features-list-user"));
    const isWithdraw = hasWithdrawPermission();
    const viewButtonTransfer = featureToggle?.includes("view_seller_transfer");
    return (
        <Flex
            maxW="100%"
            borderRadius="8px"
            width="fit-content"
            padding='16px 24px 16px 24px'
            align="center"
            justify="space-between"
            bgColor="white"
            boxShadow="md"
            gap="1rem"
        >
            <Flex
                flexDir="column"
                gap="8px"
            >
                {type === "debit_account" && hasTitle && (
                    <Heading fontSize=".8rem" color="gray.900">Conta investimento</Heading>
                )}
                {type === "acquirer_account" && hasTitle && (
                    <Heading fontSize=".8rem" color="gray.900">Conta adquirente</Heading>
                )}
                <Flex
                    flexDir="column"  
                >
                    <Text fontSize=".8rem">Saldo total</Text>
                    <Flex
                        position="relative"
                    >
                        <Text 
                            fontSize="16px"
                            position="absolute"
                            bottom="15%"
                            fontWeight={400}
                        >
                            R$
                        </Text>
                        <Text 
                            fontWeight={600} 
                            fontSize="2rem"
                            marginLeft="1.5rem"
                        >
                            {data?.totalAmount || "0,00"}
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
            {type === "acquirer_account" && (
                <>
                    <Flex
                        gap="1rem"
                    >
                        <Flex 
                            gap=".8rem"
                            flexDir="column"
                        >
                            <Text fontSize=".8rem">Disponível</Text>
                            <Text fontSize=".8rem">A liberar</Text>
                        </Flex>
                        <Flex 
                            gap=".8rem"
                            flexDir="column"
                        >
                            <Text fontSize=".8rem">{data?.amount}</Text>
                            <Text fontSize=".8rem">{data?.provisionedAmount}</Text>
                        </Flex>
                    </Flex>
                    {viewButtonTransfer && (
                        <Flex
                            flexDir="column"
                            gap="8px"
                        >
                            <Button 
                                onClick={() => open(true)}
                                disabled={isWithdrawDisabled(data, isWithdraw)} 
                                >

                                <Text
                                fontWeight="400"
                                                            >

                                Solicitar saque
                                </Text>
                            </Button>
                            <Button 
                                variant="link" 
                                size="sm"
                                disabled={!canViewTransferList(isWithdraw)}
                                onClick={() => openTransferList(true)}
                            >
                                <Text
                                fontWeight="400"
                                fontSize=".8rem"
                                >
                                    Ver solicitações
                                </Text>
                            </Button>
                        </Flex>
                    )}
                </>
            )}
        </Flex>
    )
}